import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineThickness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineThickness"><Path d="M20 5.125V6.375H4V5.125H20Z" fill="currentColor"/><Path d="M20 15.625V18.875H4V15.625H20Z" fill="currentColor"/><Path d="M20 12.125V9.875H4V12.125H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineThickness;
